// mantine
import { UnstyledButton, Button, Textarea } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
// components
import { generateReport } from '@newo/toolkit/report';
import Drawer from '@/components/Drawer';
// utils
import { useProfileQuery } from '@/services/customer/profile/profile.queries';
import useActReportDrawerStore from '@/modules/ActReportDrawer/ActReportDrawer.store.ts';

const ActReportDrawer = () => {
    const clipboard = useClipboard({ timeout: 500 });
    const act = useActReportDrawerStore((state) => state.act);
    const selectActToReport = useActReportDrawerStore(
        (state) => state.selectActToReport
    );
    const { data: profile } = useProfileQuery();
    const report = act && profile ? generateReport(act, profile) : '';

    const handleCopy = () => {
        clipboard.copy(report);
    };

    const handleCancel = () => {
        selectActToReport();
    };

    return (
        <Drawer
            withOverlay
            name="act-report-drawer"
            opened={!!act}
            position="right"
            size="sm"
            title="Report"
            onClose={handleCancel}
        >
            <div className="flex flex-col gap-4">
                <Textarea
                    readOnly
                    rows={20}
                    styles={{ input: { fontFamily: 'monospace' } }}
                    value={report}
                />

                <div className="flex justify-between gap-2">
                    <UnstyledButton
                        className="text-xs text-gray-6"
                        onClick={handleCancel}
                    >
                        Cancel
                    </UnstyledButton>
                    <Button size="xs" type="submit" onClick={handleCopy}>
                        {clipboard.copied ? 'Copied' : 'Copy'}
                    </Button>
                </div>
            </div>
        </Drawer>
    );
};

export default ActReportDrawer;
